import PurchaseModal from "../Modals/PurchaseModal";

const UNITS = [
  { key: "unit", value: "Unit", tr: "Ünite" },
  { key: "words", value: "Words", tr: "Kelimeler" },
  { key: "friends", value: "Friends", tr: "Arkadaşlar" },
  { key: "in_the_classroom", value: "In The Classroom", tr: "Sınıfta" },
  { key: "numbers", value: "Numbers", tr: "Sayılar" },
  { key: "colors", value: "Colors", tr: "Renkler" },
  { key: "at_the_playground", value: "At The Playground", tr: "Oyun Alanında" },
  { key: "body_parts", value: "Body Parts", tr: "Vücut Bölümleri" },
  { key: "pets", value: "Pets", tr: "Evcil Hayvanlar" },
  { key: "fruit", value: "Fruit", tr: "Meyveler" },
  { key: "animals", value: "Animals", tr: "Hayvanlar" },
  //3.sınıf Konuları
  { key: "greetings", value: "Greetings", tr: "Selamlaşmalar" },
  { key: "my_family", value: "My Family", tr: "Ailem" },
  { key: "people_I_love", value: "People I Love", tr: "Sevdiğim İnsanlar" },
  { key: "feelings", value: "Feelings", tr: "Duygular" },
  {
    key: "toys_and_games",
    value: "Toys And Games",
    tr: "Oyuncaklar ve Oyunlar",
  },
  { key: "my_house", value: "My House", tr: "Evim" },
  { key: "in_my_city", value: "In My City", tr: "Şehrimde" },
  { key: "transportation", value: "Transportation", tr: "Ulaşım" },
  { key: "weather", value: "Weather", tr: "Hava Durumu" },
  { key: "nature", value: "Nature", tr: "Doğa" },
  //4 sınıf konuları
  { key: "classroom_rules", value: "Classroom Rules", tr: "Sınıf Kuralları" },
  { key: "nationality", value: "Nationality", tr: "Milliyet" },
  {
    key: "cartoon_characters",
    value: "Cartoon Characters",
    tr: "Çizgi Film Karakterleri",
  },
  { key: "free_time", value: "Free Time", tr: "Boş Zaman" },
  { key: "my_day", value: "My Day", tr: "Günüm" },
  { key: "fun_with_science", value: "Fun With Science", tr: "Bilimle Eğlence" },
  { key: "jobs", value: "Jobs", tr: "Meslekler" },
  { key: "my_clothes", value: "My Clothes", tr: "Kıyafetlerim" },
  { key: "my_friends", value: "My Friends", tr: "Arkadaşlarım" },
  {
    key: "food_and_drinks",
    value: "Food And Drinks",
    tr: "Yiyecek ve İçecekler",
  },
  //5 sınıf konuları
  { key: "hello", value: "hello", tr: "Merhaba" },
  { key: "my_town", value: "My Town", tr: "Kasabam" },
  {
    key: "games_hobbies",
    value: "Games and Hobbies",
    tr: "Oyunlar ve Hobiler",
  },
  { key: "my_daily_routine", value: "My Daily Routine", tr: "Günlük Rutinim" },
  { key: "health", value: "Health", tr: "Sağlık" },
  { key: "party_time", value: "Party Time", tr: "Parti Zamanı" },
  { key: "fitness", value: "Fitness", tr: "Fitness" },
  {
    key: "the_animal_shelter",
    value: "The Animal Shelter",
    tr: "Hayvan Barınağı",
  },
  { key: "festivals", value: "Festivals", tr: "Festivaller" },
];

const SECTIONS = [
  { key: "section", value: "Section" },
  { key: "Vocabulary", value: "Vocabulary" },
  { key: "exercise_1", value: "Exercise 1" },
  { key: "exercise_2", value: "Exercise 2" },
  { key: "reading_1", value: "Reading 1" },
  { key: "reading_2", value: "Reading 2" },
  { key: "reading_3", value: "Reading 3" },
  { key: "reading_4", value: "Reading 4" },
  { key: "reading_5", value: "Reading 5" },
  { key: "speaking_1", value: "Speaking 1" },
  { key: "speaking_2", value: "Speaking 2" },
  { key: "speaking_3", value: "Speaking 3" },
  { key: "speaking_4", value: "Speaking 4" },
  { key: "listening_1", value: "Listening 1" },
  { key: "listening_2", value: "Listening 2" },
  { key: "listening_3", value: "Listening 3" },
  { key: "listening_4", value: "Listening 4" },
];

const activities = [
  {
    id: "Vocabulary",
    icon: "✍️",
    title: "Vocabulary",
    tr: "kelime",
    description: "Practice with fun activities",
    color: "bg-purple-500",
  },
  {
    id: "Grammar",
    icon: "📖",
    title: "Grammar",
    tr: "dil bilgisi",
    description: "Read stories about animals",
    color: "bg-purple-500",
  },
  {
    id: "Reading",
    icon: "🔉",
    title: "Reading",
    tr: "okuma",
    description: "Listen to animal sounds",
    color: "bg-purple-500",
  },
  {
    id: "Speaking",
    icon: "🎤",
    title: "Speaking",
    tr: "konuşma",
    description: "Practice pronunciation",
    color: "bg-purple-500",
  },
];

// Benzersiz ID oluşturmak için yardımcı fonksiyon
const generateId = (baseId, index, isActive) => {
  // İlk iki modal için her zaman orijinal ID'yi döndür (PurchaseModal olmasın)
  if (baseId === "VocableryModal" || baseId === "ExercizeModal1") {
    return baseId;
  }
  return isActive ? baseId : `PurchaseModal_${baseId}_${index}`;
};

const readingSections = (readingClass) => [
  {
    id: generateId("ReadingModel1", 1, readingClass),
    title: "Reading 1",
    icon: "📖",
    color: "#7ED321",
    description: "Short stories",
    URL: "detail_reading1",
  },
  {
    id: generateId("ReadingModel2", 2, readingClass),
    title: "Reading 2",
    icon: "📗",
    color: "#50E3C2",
    description: "Exciting adventures",
    URL: "detail_reading2",
  },
  {
    id: generateId("ReadingModel3", 3, readingClass),
    title: "Reading 3",
    icon: "📙",
    color: "#F5A623",
    description: "Fun tales",
    URL: "detail_reading3",
  },
  {
    id: generateId("ReadingModel4", 4, readingClass),
    title: "Reading 4",
    icon: "📘",
    color: "#4A90E2",
    description: "Amazing stories",
    URL: "detail_reading4",
  },
  {
    id: generateId("ReadingModel5", 5, readingClass),
    title: "Reading 5",
    icon: "📕",
    color: "#BD10E0",
    description: "Epic adventures",
    URL: "detail_reading5",
  },
];

const activityCards = (exercisesClass) => [
  {
    id: generateId("VocableryModal", 1, exercisesClass),
    title: "Vocabulary",
    icon: "📚",
    color: "#FF6B6B",
    description: "Learn new words",
  },
  {
    id: generateId("ExercizeModal1", 2, exercisesClass),
    title: "Exercise 1",
    scoreValue: "Exercise 1",
    icon: "✏️",
    color: "#4ECDC4",
    description: "Practice your skills",
  },
  {
    id: generateId("ExercizeModel2", 3, exercisesClass),
    title: "Exercise 2",
    scoreValue: "Exercise 2",
    icon: "📝",
    color: "#45B7D1",
    description: "More fun practice",
  },
  {
    id: generateId("ExercizeModel3", 4, exercisesClass),
    title: "Exercise 3",
    scoreValue: "Exercise 3",
    icon: "🐍",
    color: "#96CEB4",
    description: "Challenge yourself",
  },
  {
    id: generateId("ExerciseModel4", 5, exercisesClass),
    title: "Exercise 4",
    scoreValue: "Exercise 4",
    icon: "🐉",
    color: "#FFEAA7",
    description: "Advanced practice",
  },
  {
    id: generateId("ExerciseModel5", 6, exercisesClass),
    title: "Exercise 5",
    scoreValue: "Exercise 5",
    icon: "🎯",
    color: "#DDA0DD",
    description: "Master your skills",
  },
  {
    id: generateId("GrammerModal", 7, exercisesClass),
    title: "Grammer",
    scoreValue: "Grammer",
    icon: "📝",
    color: "#dbb376",
    description: "Learn better English",
  },
];

const speakingSections = (speakingClass) => [
  {
    id: generateId("SpeakingModel1", 1, speakingClass),
    title: "Speaking 1",
    icon: "🦜",
    color: "#FF9FF3",
    description: "Practice speaking skills",
  },
  {
    id: generateId("SpeakingModel2", 2, speakingClass),
    title: "Speaking 2",
    icon: "🎤",
    color: "#54A0FF",
    description: "Improve pronunciation",
  },
  {
    id: generateId("SpeakingModel3", 3, speakingClass),
    title: "Speaking 3",
    icon: "🗣️",
    color: "#5F27CD",
    description: "Conversation practice",
  },
  {
    id: generateId("SpeakingModel4", 4, speakingClass),
    title: "Speaking 4",
    icon: "🎙️",
    color: "#00D2D3",
    description: "Advanced speaking",
  },
];

const listeningSections = (listeningClass) => [
  {
    id: generateId("ListeningModel1", 1, listeningClass),
    title: "Listening 1",
    icon: "📣",
    color: "#FF9F43",
    description: "Basic listening skills",
  },
  {
    id: generateId("ListeningModel2", 2, listeningClass),
    title: "Listening 2",
    icon: "🔉",
    color: "#10AC84",
    description: "Audio comprehension",
  },
  {
    id: generateId("ListeningModel3", 3, listeningClass),
    title: "Listening 3",
    icon: "📢",
    color: "#EE5A6F",
    description: "Story listening",
  },
  {
    id: generateId("ListeningModel4", 4, listeningClass),
    title: "Listening 4",
    icon: "🎧",
    color: "#FD79A8",
    description: "Advanced listening",
  },
];

export {
  UNITS,
  SECTIONS,
  activityCards,
  readingSections,
  speakingSections,
  listeningSections,
  activities,
};
